<template>
  <vs-popup class="add-new-task-instance"
            id="popup"
            :title="isCreateMode ? 'ADD ACTIVE TASK' : 'UPDATE ACTIVE TASK'"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
        <div class="vx-row mb-3">
        <div class="vx-col md:w-full w-full md:mb-0">
        <small class="label">Department</small>
        <v-select
          name="department"
          v-model="form.departments"
          :options="departments"
          label="name"
          :reduce="dept => dept.id"
          placeholder="Select Department"
          multiple :closeOnSelect="false" 
        />
        </div>
        </div>
        <div class="vx-row mb-3">
                <div class="vx-col md:w-full w-full md:mb-0">
                     <!-- Staff -->
                    <small class="label">Assigned To</small>
                    <v-select :key="'staff-dropdown'" @search="onSearch" :clearable="true" name="staff" placeholder=""
                              label="name" v-model="form.staff" :reduce="option => option.id" multiple :closeOnSelect="false" 
                              :options="staffs" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                      <template slot="no-options">
                        type to search staff
                      </template>
                    </v-select>
                </div>
        </div>
       <div class="vx-row mb-3" style="height: 100px;">
            <div class="w-full vx-col md:w-1/2 md:mb-0">
                 <small class="label">Scheduled Date</small>
                <flat-pickr class="w-full" :config="flatPkrConfig" v-model="form.scheduled_date" placeholder="Choose Date" />
            </div>

              <div class="w-full vx-col md:w-1/2 md:mb-0">
                <small class="label flex items-center"><span class="mr-1" v-if="perpetual == true">No </span>Due Date <vs-checkbox class="pb-1" style="margin-top: -0.25rem !important;" v-model="perpetual"></vs-checkbox></small>
                <flat-pickr v-if="perpetual == false" class="w-full" :config="flatPkrConfig" v-model="form.due_date" placeholder="Choose Date" />
              </div>
            </div>
        </div>
      
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-task-instance-popup" @submit.prevent="handleSubmit(onClickCreateTaskInstance)" autocomplete="off">

          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="mt-2 ml-auto">Create</vs-button>
            <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>

  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  const DepartmentsRepository = RepositoryFactory.get('departments');
  const ScheduledTasksRepository = RepositoryFactory.get('scheduled_tasks');
  const DropDownRepository = RepositoryFactory.get('drop_down');
  import flatPickr from "vue-flatpickr-component";
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from 'vue-select'

  function initialState() {
    return {
      open: false,
      id: '',
      form: {
        scheduled_date:'',
        due_date:'',
        departments:[],
        scheduled_task_schedule_id: '',
        staff:[]
      },
      taskData : {},
      staffs:[],
      isCreateMode: true,
      perpetual: true,
      departments:[]
    }
  }

  export default {
    name: 'CreateTaskInstance',
    data() {
      return initialState()
    },
    components: {
    'v-select': vSelect,
    flatPickr,
    },
    methods: {
      async openPopup(data) {
        try {
          Object.assign(this.$data, initialState());
          this.$refs.form.reset();
          this.open = true;
           this.isCreateMode = true
            this.id = data.id
            this.taskData = data
            this.form.scheduled_task_schedule_id = this.taskData.id;
             this.form.departments =  this.taskData.departments ? this.taskData.departments.map((x) => x.id) : [];
            this.form.staff = this.taskData.staff ? this.taskData.staff.map((x) => x.id) : [];;
            await this.getDepartments();
            await this.getStaffList(this.form.departments);
        } catch (error) {
        }
      },
      async fetchTemplateDetails() {
      
      },
      async onClickCreateTaskInstance() {
        const vue = this;
        await this.$vs.loading({
          container: '#create-task-instance-popup',
          scale: 0.45
        })
        try {
          const {data} = await ScheduledTasksRepository.createTaskInstance(this.form);
          this.showSuccessMessage('Template added successfully');
          this.open = false;
        } catch (e) {
          this.$vs.loading.close('#create-task-instance-popup > .con-vs-loading')
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-task-instance-popup > .con-vs-loading')
      },
      async getDepartments(){
        const {data} = await DepartmentsRepository.get(' ', '', '', '' )
        this.departments =  data.data
      },
      async getStaffList(departmentIds = []) {
      let query = `filter[is_active]=1`;
      
      if (departmentIds.length > 0) {
        // example: filter[departments]=1,2,3
        query += `&filter[department-ids]=${departmentIds.join(',')}`;
      }
      const { data: staffResponse } = await DropDownRepository.getStaffList(query);

      this.staffs = staffResponse.data;
    },
      onSearch(search, loading) {
      // if(search.length) {
        loading(true);
        this.searchStaff(loading, search, this);
      // }
      },
     searchStaff: _.debounce(async (loading, search, vm) => {
      loading(true);

      // Read departments from your form
      const deptIds = Array.isArray(vm.form.departments)
        ? vm.form.departments.join(',')
        : '';

      let query = `filter[search]=${search}&filter[is_active]=1`;

      if (deptIds) {
        query += `&filter[department-ids]=${deptIds}`;
      }

      const { data } = await DropDownRepository.getStaffList(query);

      vm.staffs = data.data;
      loading(false);
    }, 350),
    },
    computed:{
    flatPkrConfig(){
    return {
        dateFormat: 'd/m/Y',
    }
    }
    },
    watch: {
    'form.departments': {
      async handler(newVal) {
        // Reset selected staff if needed
        // this.form.staff = null;

        let deptsToSearch = newVal.map(item => {
        if(item.id){
          return item.id
        }
        else {
        return item
        }
        })
        // Call your API
        await this.getStaffList(deptsToSearch);
      },
      deep: true
    }
    },
    mixins: [SuccessMessage, ErrorMessages],
    
  }
</script>

<style scoped>
  .add-new-carrier >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 30% !important;
  }

</style>
